<template>
  <div />
</template>

<script>

export default {
  computed: {
    me() {
      return this.$store.getters['auth/getUser']
    },
  },
  mounted() {
    if (this.me.id) {
      this.$store.dispatch('auth/logout')
        .finally(() => {
          this.$router.push({ name: 'login' })
          window.toast.notify.success(this.$t('auth.logout-success'))
        })
    } else {
      this.$router.push({ name: 'login' })
    }
  },
}
</script>
